import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { Layout } from '../../models/layout';
import { LayoutService } from '../../services/layout.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceAutoComplete } from '../../../../documents/document-reference/reference-auto-complete';
import { ItemService } from '../../services/item-service.service';
@Component({
  selector: 'app-layout-edit',
  templateUrl: './layout-edit.component.html',
  styleUrls: ['./layout-edit.component.css']
})
export class LayoutEditComponent extends EditForm<Layout> implements OnInit {

  constructor(
    ns: ToastrService,          
    tr: TranslateService,
    r: Router,
    ds:LayoutService,
    ar: ActivatedRoute,
    l:Location,
    private ItemService:ItemService 
  ) {
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/layout');
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      plasardLayoutTypeId: new FormControl(),
      picture: new FormControl(),
      itemId: new FormControl(null, Validators.required),        
      itemName: new FormControl(null),
      itemQuantity: new FormControl(1),
      itemPrice: new FormControl(0),
      itemPriceInternal: new FormControl(0),
      itemAmount: new FormControl(0),
      itemAmountInternal: new FormControl(0)      
    });
    super.ngOnInit();
  }

  onFileUpload(file:IFileStoreItem){
    if(file){
      this.form.controls['picture'].setValue(file.id);
    }
    else {
      this.form.controls['picture'].setValue(null);
    }
  }
  onItemSelected(item:ReferenceAutoComplete){
    //Item
    if(item && item.id){
      this.ItemService.Get(item.id).subscribe(response => {
        const quantity:number = this.form.get('itemQuantity').value;
        if(response && response.payload){
          if(!quantity){
            this.form.get('itemQuantity').setValue(1);
            this.form.get('itemPrice').setValue(response.payload.price);
            this.form.get('itemPriceInternal').setValue(response.payload.priceInternal);            
            this.form.get('itemAmount').setValue(response.payload.price);
            this.form.get('itemAmountInternal').setValue(response.payload.priceInternal);                        
          }          
        }
      })
    }
  }  
}
